/**
 * แปลงตำแหน่งที่ backend ส่งมา (`ผ.4!L33`) ให้เป็น reference ที่ Excel รับได้ใน
 * กล่อง Ctrl + G
 *
 * ชื่อชีตของไฟล์แผนวิ่งมีจุดอยู่ข้างใน (`ผ.4`) ถ้าไม่ครอบด้วย single quote
 * Excel จะอ่าน `ผ.4!L33` ไม่ออกและเด้ง error — ส่วนชื่อที่มี quote อยู่แล้วต้อง
 * escape เป็น double quote ตามไวยากรณ์ของ Excel
 */
export const toExcelReference = (location: string): string => {
  const separatorAt = location.indexOf("!");
  if (separatorAt < 0) return location;

  const sheet = location.slice(0, separatorAt);
  const cell = location.slice(separatorAt + 1);
  if (!sheet || !cell) return location;

  return `'${sheet.replace(/'/g, "''")}'!${cell}`;
};
